import {
    buildConfigSlice,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import {
    initialCandlestickTileConfigState,
    CandlestickTileConfigState,
} from './CandlestickTileConfigState';
import { selectCandlestickTileState } from '../selectors';

export const buildCandlestickTileConfigSlice = () =>
    buildConfigSlice<CandlestickTileConfigState>(
        WidgetType.CANDLESTICK_TILE,
        selectCandlestickTileState,
        initialCandlestickTileConfigState
    );

export const useCandlestickTileConfigSlice = () =>
    useConfigSlice(buildCandlestickTileConfigSlice());

export type CandlestickTileConfigPayloadType =
    WidgetConfigSliceActionPayloadType<CandlestickTileConfigState>;
